import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"
import { Redirect } from 'react-router-dom'

import cookie from 'react-cookies'

import {
  addClass,
  removeClass,
  closest,
  clearFormError,
  getJSON,
  getJSON_and_status
} from '../components/GlobalFunctions';

import SingleInput from '../components/SingleInput';
import CheckRadio from '../components/CheckRadio';
import SelectCustom from 'react-select';

import ReCAPTCHA from '../components/ReCaptcha';

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import registration_1 from '../img/registr/registr-1.svg'
import registration_2 from '../img/registr/registr-2.svg'
import registration_3 from '../img/registr/registr-3.svg'
import registration_4 from '../img/registr/registr-4.svg'

import ogp_cover from '../img/cover.png'

let reCaptcha;

export default class Register extends React.Component {

  constructor(props) {
    super(props);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.handleFocus = this.handleFocus.bind(this);

    this.checkRegistartion = this.checkRegistartion.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.handleTypeAccount = this.handleTypeAccount.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.confirmPrivicy = this.confirmPrivicy.bind(this);

    this.buildForm = this.buildForm.bind(this);
    this.checkForm = this.checkForm.bind(this);
    this.checkFormStep2 = this.checkFormStep2.bind(this);

    this.initFacebook = this.initFacebook.bind(this);
    this.statusFacebookCallback = this.statusFacebookCallback.bind(this);
    this.checkFormFacebook = this.checkFormFacebook.bind(this);
    this.handleFacebook = this.handleFacebook.bind(this);

    this.state = {
      step: 1,
      tokenFacebook: null,
      codeFacebook: null,

      statusPage: false,
      redirectPage: false,
      redirectPath: '',
      statusFormAllow: false,
      email: "",
      selectValue: "",
      typeAccount: [],
      typeAccountSelected: [],
      options: [],
      checkPrivacy: false,
      arrayFingerPrint: '',
      hashFingerPrint: '',

      registrError: '',
      registrDisabled: false,
      facebookDisabled: false
    };
  }

  updateValue (newValue) { this.setState({ selectValue: newValue }) }

  handleEmailChange(e) { this.setState({ email: e.target.value }) }

  handleTypeAccount(e) { this.setState({ typeAccountSelected: [e.target.value] }) }

  handleFocus(e) { addClass(closest(e.target, ".form-row"),"input--filled"),this.setState({ registrError: '' }) }

  handleBlur(e) { (""===this.value||null===this.value)&&removeClass(closest(e.target, ".form-row"),"input--filled") }

  pageClick(e) { document.getElementsByTagName('body')[0].className='' }

  onInputFocus(s){ addClass(s.target.parentNode,"input--filled"),this.setState({ registrError: '' }) }

  onInputBlur(s){ ""===s.target.value.trim()&&removeClass(s.target.parentNode,"input--filled") }

  confirmPrivicy(e) { (this.state.checkPrivacy)?this.setState({ checkPrivacy: false }):this.setState({ checkPrivacy: true }) }

  _getCurrentStep() {
    switch (this.state.step) {
      case 1:
        return <form id="registrForm" className="form form-form-facebook" action="" onSubmit={this.checkForm}>
              <div className="form-info">You can start registration by signing in to your Facebook account.</div>
              <div id="registrError" className="form-error" dangerouslySetInnerHTML={{ __html: this.state.registrError }}></div>

              <div className="form-row form-row-checkradio form-checkbox">
                <label className="form-checkradio-label">
                  <input type="checkbox" className="form-checkradio-input" name="checkPrivacy" onChange={this.confirmPrivicy} />
                  <span className="form-checkradio-input-checked"></span> I have read and agreed to <Link to="/privacy_policy.html">Privacy Policy</Link>
                </label>
              </div>

              <div className="form-row form-row-facebook">
                <button id="facebookSubmit" className={(!this.state.checkPrivacy) ? "form-button-disabled form-facebook" : "form-facebook"} type="button" onClick={this.handleFacebook} disabled={!this.state.checkPrivacy||this.state.facebookDisabled}><svg viewBox="0 0 20 20"><path fill="#ffffff" d="M15,3.6h-1.8c-1.4,0-1.7,0.7-1.7,1.7v2.2h3.4l-0.5,3.4h-2.9v8.8H8v-8.8H5V7.4h3V4.9C8,2,9.7,0.4,12.4,0.4 c1.2,0,2.3,0.1,2.6,0.1V3.6z"/></svg>Sign Up with Facebook</button>
              </div>
              { +process.env.RECAPTCHA_ENABLED ? (
                <ReCAPTCHA
                  ref={e => reCaptcha = e}
                  sitekey={process.env.SITE_KEY}
                />
              ) : '' }
            </form>;
      case 2:
        return <form id="registrForm" className="form form-form-facebook" action="" onSubmit={this.checkFormStep2}>
              <div id="registrError" className="form-error" dangerouslySetInnerHTML={{ __html: this.state.registrError }}></div>

              <div className="form-row login-form-row-select" title="Your country">
                <SelectCustom
                  value={this.state.selectValue}
                  required={true}
                  clearable={false}
                  onChange={this.updateValue}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                  id="registrCountry"
                  name="registrCountry"
                  options={this.state.options}
                  placeholder="Choose your country" />

                <svg viewBox="0 0 20 20"><path fill="#D2D2D2" d="M16,10c0,3.3-2.7,6-6,6s-6-2.7-6-6s2.7-6,6-6S16,6.7,16,10z M12,8.2c0,0,0.1-0.1,0.1-0.2l0.1-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.4,0,0.4,0.1c0,0,0.1-0.2,0.2-0.2s0.2,0,0.4,0V7.5c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0.1c0-0.1-0.1,0-0.2,0c-0.2,0-0.1-0.1-0.2-0.4c0-0.1-0.1-0.1-0.1-0.1s0-0.1-0.1-0.1l-0.1,0.1c-0.1,0-0.1,0-0.1,0h-0.1c0.1,0-0.1-0.1-0.1-0.1c0.1,0,0-0.1,0-0.2l0,0c0-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.5-0.1-0.5-0.1c-0.1,0,0,0.2,0,0.2c0,0.1-0.1,0.1-0.1,0.2s0.2,0.1,0.2,0.2s-0.2,0.1-0.2,0.2c-0.1,0.1,0,0.2,0.1,0.2c-0.1,0.2-0.2,0.2-0.2,0.2c-0.1,0.1-0.2-0.1-0.2-0.2s0-0.2-0.1-0.2h-0.2c0-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.2,0-0.5,0c0,0,0-0.2-0.1-0.2c0-0.1,0-0.1,0-0.2s0-0.1,0.1-0.2c0,0,0.2-0.2,0.1-0.2c0.1,0,0.2,0,0.4-0.1s0.1-0.2,0.1-0.2c0.1-0.1,0.2,0,0.4,0s0.1-0.1,0.1-0.2c0.1,0,0-0.2,0-0.2c-0.1,0-0.4,0-0.2,0.1c0,0-0.2,0.4-0.4,0.2c0,0,0-0.2-0.1-0.2S9.9,5.4,9.9,5.4c0-0.1-0.2-0.1-0.2-0.2c0.1-0.1,0-0.1-0.1-0.2c-0.1,0-0.2-0.1-0.4,0C9.1,5.3,9.4,5.3,9.5,5.4l0.1,0.1L9.4,5.7c0,0.1,0,0.1,0,0.2C9.3,5.8,9.3,5.7,9.2,5.5c0.1,0.1-0.2,0-0.2,0c-0.1,0-0.4,0.1-0.4,0c0,0,0-0.2,0-0.1C8.5,5.3,8.5,5.3,8.4,5.2C8.1,5.3,7.9,5.4,7.6,5.5c0,0,0,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4,0l0,0c0,0.1,0.1,0.1,0.1,0.2c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0.1v0.1C8,5.7,7.9,5.5,7.8,5.5c-0.1,0-0.1,0-0.1,0C6.8,6,6.2,6.6,5.8,7.3c0,0,0.1,0,0.1,0.1c0.1,0,0,0.2,0.1,0.1v0.1l0.4,0.2L6.5,8c0,0,0,0.1-0.1,0.1L6.2,8c0,0,0,0.2,0.1,0.2c-0.1,0.1,0,0.6-0.1,0.7l0,0c0,0.1,0,0.5,0.2,0.5c-0.1,0,0.2,0.4,0.2,0.4C6.8,9.9,6.9,9.9,7.1,10s0.1,0.2,0.2,0.4c0,0.1,0.1,0.2,0.1,0.4l0,0c0,0.1,0.2,0.1,0.2,0.2c0,0.1,0,0.2,0.1,0.2c0-0.1-0.1-0.4-0.2-0.5c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1-0.1-0.2l0.2,0.1c-0.1,0.1,0.2,0.5,0.4,0.6c0,0,0.2,0.2,0.1,0.2c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0,0.2,0.1,0.4c0,0.1,0.2,0.2,0.4,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0.1,0.2,0,0.4,0c0.2,0,0.2,0.2,0.4,0.2s0.4,0.1,0.5,0.1c0,0,0.1,0.4,0.2,0.4c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0,0,0-0.1c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.2,0.1-0.2c-0.1,0.1-0.4,0-0.4-0.1c0,0-0.1-0.2,0-0.2s0-0.1,0-0.2s-0.1-0.2-0.2-0.2c0,0.1-0.2,0.1-0.2,0v0.1h-0.1c0-0.1,0-0.2,0-0.4s0.4-0.5,0-0.4c-0.1,0-0.1,0-0.2,0.1c0,0.1,0,0.2-0.1,0.2s-0.4,0-0.4,0c-0.1-0.1-0.2-0.4-0.2-0.5c0-0.2,0.1-0.4,0-0.6l0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0-0.1,0c0.1,0,0.4-0.1,0.5,0c0.1,0,0.1,0.1,0.1,0c0,0,0-0.1,0-0.2c0,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.4,0.1,0.4c0.1,0.1,0.1-0.1,0.1-0.2v-0.2c-0.2,0-0.1-0.2,0-0.4l0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.1-0.1l-0.1-0.1V9.8c0.1,0,0-0.1,0.1-0.1c0.1,0.1,0.2,0,0.1-0.1c0.1-0.1,0.2,0,0.4-0.1c0.1,0,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0,0,0.2-0.1,0.1-0.1c0.1,0,0.4-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.1h0.1c0.1-0.1,0-0.1,0-0.1c-0.1,0-0.2,0-0.4,0.1C12.1,8.1,12,8.2,12,8.2z M13.6,13.5c0,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2-0.1c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.1-0.4-0.1l-0.1,0.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.2-0.4,0c-0.1,0.1,0,0.1-0.1,0.2c-0.1-0.1,0.1-0.2,0-0.2c-0.1-0.1-0.2,0.1-0.4,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.2c0-0.1-0.1,0-0.1-0.1c0,0.2,0,0.4,0.1,0.6c0,0.1,0,0.2-0.1,0.4c-0.1,0.1-0.2,0.2-0.2,0.4s0,0.2,0.1,0.2c0,0.1-0.1,0.2-0.1,0.4v0.1C12,14.8,12.9,14.2,13.6,13.5z"/></svg>
              </div>

              <div className="form-row form-row-submit">
                <input id="registrSubmit" className="form-submit" type="submit" value="Continue" disabled={this.state.registrDisabled} />
              </div>
              { +process.env.RECAPTCHA_ENABLED ? (
                <ReCAPTCHA
                  ref={e => reCaptcha = e}
                  sitekey={process.env.SITE_KEY}
                />
              ) : '' }
            </form>;
      default:
        throw 'Invalid Step';
    }
  }

  initFacebook() {
    var self = this;

    if(!document.getElementById('facebook-jssdk')) {
      window.fbAsyncInit = function() {
        FB.init({
          appId: process.env.FACEBOOK_API_APP_KEY,
          cookie: true,
          xfbml: true,
          version: 'v5.0'
        });

      }.bind(self);

      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }
  }

  handleFacebook() {
    var self = this, CookieDialog_agreed = cookie.load('CookieDialog_agreed');

    if(CookieDialog_agreed && this.state.checkPrivacy) {
      self.setState({ facebookDisabled: true, registrError: '' });
      FB.login(function (response) {
        self.statusFacebookCallback(response);
      }, {scope: 'email,public_profile,user_location'});
    } else {
      if(!CookieDialog_agreed) {
        self.setState({ registrError: '<p>Please accept cookie policy to proceed.</p>' });
      } else {
        self.setState({ registrError: '<p>Please agree to our Privacy Policy to proceed</p>' });
      }
    }
  }

  statusFacebookCallback(response) {
    if (response.status === 'connected') {
      this.checkFormFacebook(response);
    } else {
      this.setState({ facebookDisabled: false, registrError: '<p>Please log into Facebook.<br>In case you experience any difficulties, please sign in using email and password.</p>' });
    }
  }

  checkFormFacebook(response) {
    var self = this, authResponse = response.authResponse;

    getJSON_and_status('POST', '/api/facebook/register/callback', 'authResponse[accessToken]='+authResponse.accessToken+'&authResponse[signedRequest]='+authResponse.signedRequest, async function(data){var dataArray=JSON.parse(data);

      if(dataArray.country_code) {

        self.setState({tokenFacebook: authResponse.accessToken});
        self.setState({codeFacebook: authResponse.signedRequest});

        getJSON('GET', '/api/countries', null, function(data){ 
          if (typeof data === 'string') data = JSON.parse(data);
          var dataArray=data.data, countriesArray = [];

          Object.keys(dataArray).map(function (key) { 
            if(key !== "") countriesArray.push({value: key, label: dataArray[key]})
          });

          self.setState({options: countriesArray});
          self.setState({ registrError: '<p>You need to select country</p>' });
          self.setState({step: self.state.step + 1});
        }, function(status){});

      } else {
        let recaptchaToken = '';
        if (+process.env.RECAPTCHA_ENABLED) {
          try {
            recaptchaToken = await reCaptcha.getRecaptchaToken();
          } catch (error) {
            self.setState({ loginError: '<p>'+error+'</p>' });
          }
        }
        recaptchaToken = recaptchaToken ? `&recaptchaToken=${recaptchaToken}` : '';

        getJSON('POST', '/api/facebook/register', 'token='+authResponse.accessToken+'&code='+authResponse.signedRequest+'&country_code='+dataArray.user.country_code+'&hashFingerPrint='+self.state.hashFingerPrint+'&arrayFingerPrint='+self.state.arrayFingerPrint+recaptchaToken+'&account_type=person', function(data){var dataArray=JSON.parse(data);

          if(dataArray.redirect!=='' && dataArray.redirect!=='undefined' && dataArray!=='undefined') {
            window.location.assign(dataArray.redirect);
          } else {
            self.setState({redirectPath: '/login.html'});
            self.setState({redirectPage: true});
          }

        }, function(status){
          var statusArray=JSON.parse(status);
          if(statusArray.fields && statusArray.fields !== 'undefined') {
            var registrErrorFields = '';
            if(statusArray.fields.length>0) {
              for (var i = 0; i < statusArray.fields.length; i++) {
                registrErrorFields += '<p>'+statusArray.fields[i]+'</p>';
              }
            }
            self.setState({ registrError: registrErrorFields });
          } else if(statusArray.message && statusArray.message !== 'undefined') {
            self.setState({ registrError: '<p>'+statusArray.message+'</p>' });
          }

          self.setState({ facebookDisabled: false });
        });
      }

    }, function(error, status){
      if(status === 301) {
        var statusError=JSON.parse(error);
        self.setState({statusPage: false});
        self.setState({redirectPath: statusError.redirect});
        self.setState({redirectPage: true});
      } else {
        var statusError=JSON.parse(error);
        self.setState({ facebookDisabled: false, registrError: '<p>'+statusError.message+'</p>' });
      }
    });
  }

  buildForm() {

    if (this.state && this.state.statusFormAllow) {
      return(
        <div>
          <div className="form-row form-row-or">
            <div className="form-or">OR</div>
          </div>

          <SingleInput
            inputType={'email'}
            title={'Your e-mail'}
            name={'registrEmail'}
            content={this.state.email}
            controlFunc={this.handleEmailChange}
            focusFunc={this.onInputFocus}
            blurFunc={this.onInputBlur}
            placeholder={'Enter your e-mail'}
            svg={'M14.9,8.2c-1,0.7-2.1,1.4-3.1,2.2c-0.4,0.3-1.2,0.9-1.7,0.9h0h0c-0.5,0-1.3-0.6-1.7-0.9c-1-0.7-2.1-1.5-3.1-2.2C4.7,7.9,4,7.1,4,6.5c0-0.7,0.4-1.2,1.1-1.2h9.9c0.6,0,1.1,0.5,1.1,1.1C16,7.1,15.4,7.8,14.9,8.2z M16,13.6c0,0.6-0.5,1.1-1.1,1.1H5.1c-0.6,0-1.1-0.5-1.1-1.1V8.3c0.2,0.2,0.4,0.4,0.7,0.6c1.1,0.8,2.2,1.5,3.3,2.3c0.6,0.4,1.3,0.9,2,0.9h0h0c0.7,0,1.4-0.5,2-0.9c1.1-0.8,2.2-1.6,3.3-2.3c0.2-0.2,0.5-0.4,0.7-0.6V13.6z'}
            required={true} />

          <div className="form-row login-form-row-select" title="Your country">
            <SelectCustom
              value={this.state.selectValue}
              required={true}
              clearable={false}
              onChange={this.updateValue}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              id="registrCountry"
              name="registrCountry"
              options={this.state.options}
              placeholder="Choose your country" />

            <svg viewBox="0 0 20 20"><path fill="#D2D2D2" d="M16,10c0,3.3-2.7,6-6,6s-6-2.7-6-6s2.7-6,6-6S16,6.7,16,10z M12,8.2c0,0,0.1-0.1,0.1-0.2l0.1-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.4,0,0.4,0.1c0,0,0.1-0.2,0.2-0.2s0.2,0,0.4,0V7.5c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0.1c0-0.1-0.1,0-0.2,0c-0.2,0-0.1-0.1-0.2-0.4c0-0.1-0.1-0.1-0.1-0.1s0-0.1-0.1-0.1l-0.1,0.1c-0.1,0-0.1,0-0.1,0h-0.1c0.1,0-0.1-0.1-0.1-0.1c0.1,0,0-0.1,0-0.2l0,0c0-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.5-0.1-0.5-0.1c-0.1,0,0,0.2,0,0.2c0,0.1-0.1,0.1-0.1,0.2s0.2,0.1,0.2,0.2s-0.2,0.1-0.2,0.2c-0.1,0.1,0,0.2,0.1,0.2c-0.1,0.2-0.2,0.2-0.2,0.2c-0.1,0.1-0.2-0.1-0.2-0.2s0-0.2-0.1-0.2h-0.2c0-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.2,0-0.5,0c0,0,0-0.2-0.1-0.2c0-0.1,0-0.1,0-0.2s0-0.1,0.1-0.2c0,0,0.2-0.2,0.1-0.2c0.1,0,0.2,0,0.4-0.1s0.1-0.2,0.1-0.2c0.1-0.1,0.2,0,0.4,0s0.1-0.1,0.1-0.2c0.1,0,0-0.2,0-0.2c-0.1,0-0.4,0-0.2,0.1c0,0-0.2,0.4-0.4,0.2c0,0,0-0.2-0.1-0.2S9.9,5.4,9.9,5.4c0-0.1-0.2-0.1-0.2-0.2c0.1-0.1,0-0.1-0.1-0.2c-0.1,0-0.2-0.1-0.4,0C9.1,5.3,9.4,5.3,9.5,5.4l0.1,0.1L9.4,5.7c0,0.1,0,0.1,0,0.2C9.3,5.8,9.3,5.7,9.2,5.5c0.1,0.1-0.2,0-0.2,0c-0.1,0-0.4,0.1-0.4,0c0,0,0-0.2,0-0.1C8.5,5.3,8.5,5.3,8.4,5.2C8.1,5.3,7.9,5.4,7.6,5.5c0,0,0,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4,0l0,0c0,0.1,0.1,0.1,0.1,0.2c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0.1v0.1C8,5.7,7.9,5.5,7.8,5.5c-0.1,0-0.1,0-0.1,0C6.8,6,6.2,6.6,5.8,7.3c0,0,0.1,0,0.1,0.1c0.1,0,0,0.2,0.1,0.1v0.1l0.4,0.2L6.5,8c0,0,0,0.1-0.1,0.1L6.2,8c0,0,0,0.2,0.1,0.2c-0.1,0.1,0,0.6-0.1,0.7l0,0c0,0.1,0,0.5,0.2,0.5c-0.1,0,0.2,0.4,0.2,0.4C6.8,9.9,6.9,9.9,7.1,10s0.1,0.2,0.2,0.4c0,0.1,0.1,0.2,0.1,0.4l0,0c0,0.1,0.2,0.1,0.2,0.2c0,0.1,0,0.2,0.1,0.2c0-0.1-0.1-0.4-0.2-0.5c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1-0.1-0.2l0.2,0.1c-0.1,0.1,0.2,0.5,0.4,0.6c0,0,0.2,0.2,0.1,0.2c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0,0.2,0.1,0.4c0,0.1,0.2,0.2,0.4,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0.1,0.2,0,0.4,0c0.2,0,0.2,0.2,0.4,0.2s0.4,0.1,0.5,0.1c0,0,0.1,0.4,0.2,0.4c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0,0,0-0.1c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.2,0.1-0.2c-0.1,0.1-0.4,0-0.4-0.1c0,0-0.1-0.2,0-0.2s0-0.1,0-0.2s-0.1-0.2-0.2-0.2c0,0.1-0.2,0.1-0.2,0v0.1h-0.1c0-0.1,0-0.2,0-0.4s0.4-0.5,0-0.4c-0.1,0-0.1,0-0.2,0.1c0,0.1,0,0.2-0.1,0.2s-0.4,0-0.4,0c-0.1-0.1-0.2-0.4-0.2-0.5c0-0.2,0.1-0.4,0-0.6l0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0-0.1,0c0.1,0,0.4-0.1,0.5,0c0.1,0,0.1,0.1,0.1,0c0,0,0-0.1,0-0.2c0,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.4,0.1,0.4c0.1,0.1,0.1-0.1,0.1-0.2v-0.2c-0.2,0-0.1-0.2,0-0.4l0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.1-0.1l-0.1-0.1V9.8c0.1,0,0-0.1,0.1-0.1c0.1,0.1,0.2,0,0.1-0.1c0.1-0.1,0.2,0,0.4-0.1c0.1,0,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0,0,0.2-0.1,0.1-0.1c0.1,0,0.4-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.1h0.1c0.1-0.1,0-0.1,0-0.1c-0.1,0-0.2,0-0.4,0.1C12.1,8.1,12,8.2,12,8.2z M13.6,13.5c0,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2-0.1c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.1-0.4-0.1l-0.1,0.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.2-0.4,0c-0.1,0.1,0,0.1-0.1,0.2c-0.1-0.1,0.1-0.2,0-0.2c-0.1-0.1-0.2,0.1-0.4,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.2c0-0.1-0.1,0-0.1-0.1c0,0.2,0,0.4,0.1,0.6c0,0.1,0,0.2-0.1,0.4c-0.1,0.1-0.2,0.2-0.2,0.4s0,0.2,0.1,0.2c0,0.1-0.1,0.2-0.1,0.4v0.1C12,14.8,12.9,14.2,13.6,13.5z"/></svg>
          </div>

          <CheckRadio 
            title={'Your type account'}
            setName={'typeaccount'}
            controlFunc={this.handleTypeAccount}
            type={'radio'}
            options={this.state.typeAccount}
            selectedOptions={this.state.typeAccountSelected} />

          <div className="form-row form-row-submit">
            <input id="registrSubmit" className={'form-submit'} type="submit" value="Submit" disabled={this.state.registrDisabled} />
          </div>

          { +process.env.RECAPTCHA_ENABLED ? (
            <ReCAPTCHA
              ref={e => reCaptcha = e}
              sitekey={process.env.SITE_KEY}
            />
          ) : '' }
        </div>
      );
    }
  }

  async checkForm(e) {
    e.preventDefault();
    var self = this, CookieDialog_agreed = cookie.load('CookieDialog_agreed');

    if(!CookieDialog_agreed) {
      self.setState({ registrError: '<p>Please accept cookie policy to proceed.</p>' });
    } else {

      self.setState({ registrDisabled: true, registrError: '' });

      let recaptchaToken = '';
      if (+process.env.RECAPTCHA_ENABLED) {
        try {
          recaptchaToken = await reCaptcha.getRecaptchaToken();
        } catch (error) {
          self.setState({ loginError: '<p>'+error+'</p>' });
        }
      }
      recaptchaToken = recaptchaToken ? `&recaptchaToken=${recaptchaToken}` : '';

      getJSON('POST', '/api/register', 'email='+this.state.email+'&hashFingerPrint='+self.state.hashFingerPrint+'&arrayFingerPrint='+self.state.arrayFingerPrint+'&country_code='+this.state.selectValue.value+recaptchaToken+'&account_type='+this.state.typeAccountSelected, function(data){var dataArray=JSON.parse(data);
        self.setState({redirectPath: '/register_hash.html'});
        self.setState({redirectPage: true});
      }, function(status){
        var statusArray=JSON.parse(status);
        if(statusArray.fields && statusArray.fields !== 'undefined') {
          var registrErrorFields = '';
          if(statusArray.fields.length>0) {
            for (var i = 0; i < statusArray.fields.length; i++) {
              registrErrorFields += '<p>'+statusArray.fields[i]+'</p>';
            }
          }
          self.setState({ registrError: registrErrorFields });
        } else if(statusArray.message && statusArray.message !== 'undefined') {
          self.setState({ registrError: '<p>'+statusArray.message+'</p>' });
        }
        self.setState({ registrDisabled: false });
      });
    }
  }

  async checkFormStep2(e) {
    e.preventDefault();
    var self = this, CookieDialog_agreed = cookie.load('CookieDialog_agreed');

    if(!CookieDialog_agreed) {
      self.setState({ registrError: '<p>Please accept cookie policy to proceed.</p>' });
    } else {

      self.setState({ registrDisabled: true, registrError: '' });

      let recaptchaToken = '';
      if (+process.env.RECAPTCHA_ENABLED) {
        try {
          recaptchaToken = await reCaptcha.getRecaptchaToken();
        } catch (error) {
          self.setState({ loginError: '<p>'+error+'</p>' });
        }
      }
      recaptchaToken = recaptchaToken ? `&recaptchaToken=${recaptchaToken}` : '';

      getJSON('POST', '/api/facebook/register', 'token='+this.state.tokenFacebook+'&code='+this.state.codeFacebook+'&country_code='+this.state.selectValue.value+'&hashFingerPrint='+self.state.hashFingerPrint+'&arrayFingerPrint='+self.state.arrayFingerPrint+recaptchaToken+'&account_type=person', function(data){var dataArray=JSON.parse(data);

        if(dataArray.redirect!=='' && dataArray.redirect!=='undefined' && dataArray!=='undefined') {
          window.location.assign(dataArray.redirect);
        } else {
          self.setState({redirectPath: '/login.html'});
          self.setState({redirectPage: true});
        }

      }, function(status){
        var statusArray=JSON.parse(status);
        if(statusArray.fields && statusArray.fields !== 'undefined') {
          var registrErrorFields = '';
          if(statusArray.fields.length>0) {
            for (var i = 0; i < statusArray.fields.length; i++) {
              registrErrorFields += '<p>'+statusArray.fields[i]+'</p>';
            }
          }
          self.setState({ registrError: registrErrorFields });
        } else if(statusArray.message && statusArray.message !== 'undefined') {
          self.setState({ registrError: '<p>'+statusArray.message+'</p>' });
        }
        self.setState({ registrDisabled: false });
      });
    }
  }

  checkRegistartion() {
    var self = this;
    getJSON('GET', '/api/register/allow', null, function(data){var dataArray=data;
      if(!dataArray.is_allow) {
        self.setState({redirectPath: '/register_closed.html'});
        self.setState({redirectPage: true});
      } else {
        self.setState({statusPage: true});
      }
    }, function(status){});
  }

  componentDidMount() {
    var isBrowser = typeof window !== 'undefined';
    var fingerprint = isBrowser ? require('fingerprintjs2') : undefined;
    var self = this;

    new fingerprint().get(function(result, components) {
      self.setState({ hashFingerPrint: result });
      self.setState({ arrayFingerPrint: JSON.stringify(components) });
    });

    getJSON('GET', '/api/auth', null, function(data){
      if(data.log) {
        window.location.assign(process.env.GATSBY_API_URL+'/orders/available.html');
      } else {
        self.checkRegistartion();
        self.initFacebook();
      }
    }, function(status){});
  }

  componentDidUpdate() {
    var self = this;
    if(this.state.statusPage) {
      var mask = document.getElementById('mask');
      mask.addEventListener('touchstart', self.pageClick, false);

      for(var fieldList=document.querySelectorAll(".input__field"),i=0;i<fieldList.length;i++)""!==fieldList[i].value.trim()&&addClass(fieldList[i].parentNode,"input--filled");
    }
  }

  render() {
    if (this.state && (this.state.statusPage || this.state.redirectPage)) {
      if(this.state.redirectPage) {
        return (
          <div>
            <Helmet
              title="Become a writer and earn money at Uvocorp.com - UvoCorp.com"
              meta={[
                { name: "description", content: "At Uvocorp.com, you have a unique opportunity to become a remote academic writer. Earn money by writing academic assignments." },
              ]}
              link={[
                { rel: 'canonical', href: "https://www.uvocorp.com/register_email.html" }
              ]} />
            <Redirect to={this.state.redirectPath}/>
          </div>
        );
      }
      return (
        <div>
          <Helmet
            title="Become a writer and earn money at Uvocorp.com - UvoCorp.com"
            meta={[
              { name: "description", content: "At Uvocorp.com, you have a unique opportunity to become a remote academic writer. Earn money by writing academic assignments." },

              { property: 'og:title', content: "Become a writer and earn money at Uvocorp.com - UvoCorp.com" },
              { property: 'og:description', content: "At Uvocorp.com, you have a unique opportunity to become a remote academic writer. Earn money by writing academic assignments." },
              { property: 'og:site_name', content: "UvoCorp.com" },
              { property: 'og:type', content: "website" },
              { property: 'og:image', content: ogp_cover },
            ]}

            link={[
              { rel: 'canonical', href: "https://www.uvocorp.com/register_email.html" }
            ]} />

          <div className='header' id="header">
            <Navigation />
          </div>

          <div className="wrapper">

            <div className="inner-white">
              <div className="container">

                <div className="form-container registartion">
                  <h1 className="form-header">Registration</h1>
                  <div className="form-wrapper">

                    { this._getCurrentStep.call(this) }
                    
                  </div>
                </div>

              </div>
            </div>

            <div className="inner-gray">
              <div className="container">
                <div className="col-md-push-5 col-md-7">
                  <div className="hiring-alert hiring-alert-p">
                    <div className="hiring-alert-title">Warning – do not buy uvocorp accounts</div>
                    <div className="hiring-alert-text">
                      <p>Dear applicants, please <strong>never buy a registered</strong> UVOCORP account that you may find in an online advertisement. You will pay money (sometimes as much as $500) and be able to write maximum one or two papers, since all accounts, especially the new ones, are constantly checked by our quality specialists. Sold accounts are closed upon disclosure, and the payments of such account owners are suspended. During the last 2 months, we have closed more than 30 accounts from Canada, Ukraine, the USA, Russian Federation, which turned out to be either fake or sold out.</p>
                      <p>Buying accounts is pointless and not worth your money and time.</p>
                    </div>
                  </div>
                  <h2 className="inner-left">Registration Steps</h2>
                  <ol className="registr-steps">
                    <li>Provide us with your e-mail address.</li>
                    <li>Create your profile using a special link sent to your e-mail and verify your phone number; <br />As a security measure, we require all our applicants to upload a photo of themselves holding their ID for identity proof. We respect your privacy and do not disclose your personal information to the third parties.</li>
                    <li>Write a sample paper.</li>
                  </ol>
                  <p>After that we will check your profile and evaluate your sample. Usually it takes up to 4-7 business days for us to properly conduct those procedures. If your sample is approved, we will activate your writer’s account, and you will be able to start working. If not, you will have a chance to reapply in 3 months following the ‘reinstate account’ procedure by pressing the log-in button on the main page and inserting the log-in details used while registering previous time.</p>
                  <p className="registr-alert">
                    <strong>Remember:</strong> it is important to fill in the real information in your writer’s profile to avoid unnecessary delays and clarifications later on.
                  </p>
                </div>
                <div className="col-md-pull-7 col-md-5">
                  <div className="registr_img registr_img_1">
                    <img src={registration_1} alt="Registration Image1"/>
                  </div>
                </div>
              </div>
            </div>

            <div className="inner-white inner-center">
              <h2>Sample Paper</h2>
              <div className="container">
                <div className="col-sm-8">
                  <p>In order to choose the best writers, we ask all applicants to write a 5-paragraph sample paper on an automatically selected topic. Each applicant has 3 hours to complete this step. Yet we provide detailed hints and pieces of advice before you start writing the paper, which eases the process.</p>
                  <p>Generally speaking, we are looking for the writers who can properly express their thoughts and know how to support their stance. It is perfectly fine to make some mistakes; in such cases we will simply assign a professional editor to proofread your papers.</p>
                </div>
                <div className="col-sm-4">
                  <div className="registr_img registr_img_2">
                    <img src={registration_2} alt="Registration Image2"/>
                  </div>
                </div>
              </div>
            </div>

            <div className="inner-gray inner-center inner-center-md">
              <h2>Initial Steps after Approval</h2>
              <div className="container">
                <div className="col-md-push-4 col-md-8">
                  <p>All new writers (reinstated writers are considered to be new) undergo a probation period (unless otherwise notified by the Adaptation Specialist). The probation is aimed to ensure that our team is reinforced with only competent candidates. During this period, an applicant may be obliged to join the Mentoring Project or the Editing Program. If a writer is enrolled in the Editing Program, his or her papers will be checked and corrected by professional editors. If an applicant joins the Mentoring Program, he or she will work with a mentor, who will assign orders to the writer and then edit them. The probation period will end with either the account closure (if the writer fails to show good quality standards) or graduation from the Mentoring Program. <strong>The aim of both the Editing and Mentoring Programs is to ensure that each new writer passes the onboarding process with the help of more experienced writers and smoothly flows into the work.</strong></p>
                  <p>All the writers that have failed the probation period have a chance to reapply in 6 months. They only need to follow the ‘reinstate account’ procedure by pressing the log-in button on the main page and inserting the log-in details used while registering previous time.</p>
                </div>
                <div className="col-md-pull-8 col-md-4">
                  <div className="registr_img registr_img_3">
                    <img src={registration_3} alt="Registration Image3"/>
                  </div>
                </div>
              </div>
            </div>

            <div className="inner-white registr-float_img">
              <h2>Working As a Team of Writers</h2>
              <div className="container">
                <div className="col-sm-6 col-md-7 col-lg-8">
                  <p>If you decide to submit the papers completed the help of other individuals, you have to inform us about it. The word “Group” will then be added to your name, which will help us avoid confusion during the quality checks of your account and choose appropriate candidates for various promotion opportunities. Mind that you will remain responsible for the quality of your papers but will face no penalties for having a group account.</p>
                </div>
                <div className="col-sm-6 col-md-5 col-lg-4">
                  <div className="registr_img registr_img_4">
                    <img src={registration_4} alt="Registration Image4"/>
                  </div>
                </div>
              </div>
            </div>

            <Footer />

          </div>
          <div id="mask" className="c-mask"></div>

        </div>
      )
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/register_email.html.js